import { useState } from "react"

export const AdjustmentState = () =>{
    const [productList, setProductList] = useState([])
    const [productSearchList, setProductSearchList] = useState([])
    const [searchInput, setSearchInput] = useState('');
    const [infiniteState, setInfiniteState] = useState({limit:20, offset:0, infiniteLoad:false, dataType:'string'});
    const [listLoader, setListLoader] = useState({isloading:true})
    const [branchData, setBranchData] = useState([]);

    return{
        productList:{data: productList, set: setProductList},
        productSearchList:{data: productSearchList, set: setProductSearchList},
        searchInput: {data: searchInput, set: setSearchInput},
        infiniteState: {data: infiniteState, set: setInfiniteState},
        listLoader: {data: listLoader, set: setListLoader},
        branchData: {data: branchData, set: setBranchData},
    }
    
}
